/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;




/*****************
 ** WEBPACK FOOTER
 ** ./~/intl-messageformat-parser/index.js
 ** module id = 1469
 ** module chunks = 0
 **/